export default __webpack_public_path__ + "static/Copy-of-Ambient-365-December-Webinar-1-eb63acb26a368dbb37bcd77d742c3ff5.png";